import React, { Component } from 'react';
import axios from "axios";

import api from '../../../api/api';
import apiFunctions from "../../../api/functions.js"
import { formatCurrency } from '../../../functions/functions';

import Modal from "../../HistorialEncomienda/ModalEncomienda/Modal"
import ModalResumenDeuda from "./ModalResumenDeuda"

import ParadigmaTable from "../../../components/ParadigmaTable/ParadigmaTable";
import ParadigmaDatePicker from '../../../components/ParadigmaDatePicker/ParadigmaDatePicker';
import ParadigmaAsyncSeeker from '../../../components/ParadigmaAsyncSeeker/ParadigmaAsyncSeeker';
import moment from 'moment';

class EstadoDeuda extends Component {
    constructor() {
        super();
        this.state = {
            ar_estados: [],
            usuario_id: null,
            columns: [
                {
                    Header: "id",
                    id: "id",
                    accessor: "id",
                    width: 100,
                    show: false,
                    private: true,
                },
                {
                    Header: "N° Orden",
                    id: "nroOrden",
                    accessor: "nroOrden",
                    width: 150,
                    show: true,
                },
                {
                    Header: "Fecha",
                    id: "fechaIngreso",
                    accessor: d => (d.fechaIngreso) ? (moment(d.fechaIngreso).format('DD-MM-YYYY')) : (''),
                    width: 120,
                    show: true,
                    Filter: ({ filter, onChange }) => <div className={"date-filter has-value"}>
                                                        <ParadigmaDatePicker
                                                                dateFormat="DD/MM/YYYY"
                                                                value={filter ? moment(filter.value).format('DD/MM/YYYY') : ''}
                                                                onChange={date => {
                                                                    onChange((moment(date).isValid()) ? (moment(date).format('YYYY-MM-DD')) : (''))}}
                                                            />
                                                        <div className="date-filter__buttons">
                                                            <button
                                                                className="date-filter__button date-filter__button-close"
                                                                onClick={(e) => {onChange('')}}
                                                            >
                                                                <i className={'fa fa-times'}></i>
                                                            </button>
                                                        </div>
                                                    </div>
                },
                {
                    Header: "comitente",
                    id: "comitente",
                    accessor: (d) => d.comitente ? d.comitente.nombre : (''),
                    show: false,
                    private: true,
                },
                {
                    Header: "Domicilio",
                    id: "numero",
                    accessor: (e) => {
                        const calle = e.calle || '';
                        const numero = e.numero || '';
                        return (calle || numero) ? `${calle} ${numero}`.trim() : '';
                    },
                    show: true,
                },
                {
                    Header: "Telefono",
                    id: "calle",
                    accessor: (e) => (e.comitente) ? (((e.comitente.telefono) ? e.comitente.telefono+', ' : '') +  ((e.comitente.telefono2) ? e.comitente.telefono2+', ' : '')+ ((e.comitente.telefono3) ? e.comitente.telefono3+', ' : '')) : (''),
                    show: true,
                    filtered: false,
                },
                {
                    Header: "Tipo de Encomienda",
                    id: "tipoEncomienda_id",
                    lookup: "exact",
                    width: 115,
                    accessor: (e) => (e.tipoEncomienda) ? (e.tipoEncomienda.nombre) : (''),
                    show: true,
                    Filter: ({ filter, onChange }) =>
                        <ParadigmaAsyncSeeker
                            url={api.expedientes.tiposdeencomiendaSelect}
                            value={filter ? filter.value : ""}
                            onChange={data => (data) ? (onChange(data.id)): ((filter) ? onChange('') : null)}
                            parameters={{
                                paginationEnabled:false,
                                sort:['nombre'],
                            }}
                        />
                },
                {
                    Header: "Estado",
                    id: "estado",
                    accessor: e => <div
                                    className="btn py-0"
                                    style={{
                                        background: `#${this.state.ar_estados[e.estado] ? this.state.ar_estados[e.estado].background : 'bbb'}`,
                                        color: `#${this.state.ar_estados[e.estado] ? this.state.ar_estados[e.estado].color : 'fff'}`,
                                        width: 150,
                                        height: 17,
                                        fontSize: '0.8em',
                                        marginTop: '0px',
                                        borderTopWidth: '0px',
                                    }}
                                >
                                    {this.state.ar_estados[e.estado] ? this.state.ar_estados[e.estado].nombre : ''}
                                </div>,
                    width: 150,
                    show: true,
                    Filter: ({ filter, onChange }) =>
                        <ParadigmaAsyncSeeker
                            url={undefined}
                            optionDefault={this.state.ar_estados}
                            value={filter ? filter.value : ''}
                            onChange={data => (data) ? (onChange(data.id)): (onChange(''))}
                        />
                },
                {
                    Header: "Estado Deuda",
                    id: "estadoDeuda",
                    className: 'text-right',
                    width: 150,
                    accessor: (d) => '$ '+formatCurrency(d.estadoDeuda),
                    show: true,
                },
                {
                    Header: "Total Aplicado",
                    id: "totalAplicado",
                    className: 'text-right',
                    width: 150,
                    accessor: (d) => '$ '+formatCurrency(d.totalAplicado),
                    show: true,
                },
                {
                    Header: "Diferencia",
                    id: "deudaRestante",
                    className: 'text-right',
                    width: 150,
                    accessor: (d) => '$ '+formatCurrency(d.deudaRestante),
                    show: true,
                },
            ]
        };
    }

    componentDidMount = () => {
        apiFunctions.get(api.expedientes.estadosencomiendaSelect, null, null, {sort:['numero']}, (response) => {
            this.setState({
                ar_estados: response.data.map((d) => { return {id: d.numero.toString(), nombre: d.nombre, background: d.background, color: d.texto, diasEstimados: d.diasEstimados} })
            })
        });

        apiFunctions.get(api.usuarios.perfil, null, this.props.depth, null, (response) => {
            let usuario_id = (response.data.id) ? (response.data.id) : (null)
            this.setState({
                usuario_id: usuario_id,
            });
        });
    }

    render() {
        const { ar_estados, usuario_id } = this.state;
        const outerSort = [];
        
        return (
            <ParadigmaTable
                buttons={[
                    {
                        edit: true,
                        component: (props) => <ModalResumenDeuda {...props} action="DETAIL" />,
                        permission: '',
                    },
                ]}
                apiUrl={api.expedientes.encomiendaprofesionalEstadoDeuda}
                columns={this.state.columns}
                title={"Estado de Deuda"}
                outerSort={outerSort}
                depth={1}
            />
        );
    }
}

export default EstadoDeuda;



// WEBPACK FOOTER //
// ./src/views/CuentasCorrientes/EstadoDeuda/EstadoDeuda.js